import type { AnnualConst, TechnologyDatum } from "../algorithm.types";

type CalculateCarbonPerTechnologyParams = {
  annualConst: Pick<AnnualConst, "annualTechGen">;
  technologyData: ReadonlyArray<Pick<TechnologyDatum, "emissions">>;
};

export default function calculateCarbonPerTechnology({
  annualConst,
  technologyData,
}: CalculateCarbonPerTechnologyParams): Array<number> {
  // Carbon for each Tech (Mt) = Annual Tech Generation (TWh) x Emissions (t/MWh)
  return annualConst.annualTechGen.map(
    (techGen, index) => techGen * technologyData[index].emissions,
  );
}
